import React from 'react';
import { User } from '../../types';

interface DeleteUserDialogProps {
  user: User;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({
  user,
  onConfirm,
  onCancel,
  isLoading,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <h2 className="text-xl font-bold mb-4 text-red-600">Benutzer löschen</h2>
        <p className="text-gray-700 mb-6">
          Möchten Sie den Benutzer <strong>{user.username}</strong> wirklich löschen?
        </p>
        <p className="text-sm text-gray-600 mb-6">
          Diese Aktion kann nicht rückgängig gemacht werden.
        </p>
        <div className="flex gap-3">
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Wird gelöscht...' : 'Löschen'}
          </button>
          <button
            onClick={onCancel}
            disabled={isLoading}
            className="flex-1 px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteUserDialog;
